import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { cancel,
    next,
    accountRecoverySelection,
    getAccountRecovery,
    getLogins,
    resendCode,
    resetPassword,
    sendChallenge,
    submitVerificationInit,
    validateRecoveryToken,
    verifyAccountRecovery } from '../../../../actions/forgot-password'
import { selectAccountRecoveryData,
    selectAccountRecoveryStatus,
    selectData,
    selectErrorMessage,
    selectForgotPasswordSessionTimeout,
    selectPasswordStatus,
    selectResendCodeStatus,
    selectResendSuccessMsg,
    selectSendChallengeData,
    selectSendChallengeStatus,
    selectStatus,
    selectStep,
    selectUserAppsData,
    selectUserAppStatus,
    selectUserData,
    selectVerificationStatus } from '../../../../reducers/forgot-password'
import { logoutOktaSession, terminateOAGSession } from '../../../../actions/application'
import { selectLogoutStatusOkta, selectLogoutStatusOAG } from '../../../../reducers/application'


const mapStateToProps = createStructuredSelector({
    accountRecoveryData: selectAccountRecoveryData,
    accountRecoveryStatus: selectAccountRecoveryStatus,
    data: selectData,
    dataSendChallenge: selectSendChallengeData,
    dataUserApps: selectUserAppsData,
    errorMessage: selectErrorMessage,
    logoutStatusOAG: selectLogoutStatusOAG,
    logoutStatusOkta: selectLogoutStatusOkta,
    resendSuccessMsg: selectResendSuccessMsg,
    sendChallengeStatus: selectSendChallengeStatus,
    sessionTimeout: selectForgotPasswordSessionTimeout,
    status: selectStatus,
    stepNumber: selectStep,
    submitStatusPassword: selectPasswordStatus,
    submitStatusResendCode: selectResendCodeStatus,
    submitStatusVerification: selectVerificationStatus,
    userAppsStatus: selectUserAppStatus,
    userData: selectUserData
})

const mapDispatchToProps = dispatch => {
    return {
        changeStep: () => dispatch(next()),
        getAccountRecovery: oktaUserId => dispatch(getAccountRecovery(oktaUserId)),
        init: recoveryToken => dispatch(validateRecoveryToken(recoveryToken)),
        initSendChallenge: recoveryType => dispatch(sendChallenge(recoveryType)),
        initUserApps: () => dispatch(getLogins()),
        logoutOktaSession: url => dispatch(logoutOktaSession(url)),
        onAccountRecoverySelection: () => dispatch(accountRecoverySelection()),
        onCancel: () => dispatch(cancel()),
        onResendCode: recoveryType => dispatch(resendCode(recoveryType)),
        onSubmitPassword: password => dispatch(resetPassword(password)),
        onSubmitVerificationInit: passCode => dispatch(submitVerificationInit(passCode)),
        onVerifyAccountRecovery: ({ passCode, recoveryType }) => dispatch(verifyAccountRecovery({ passCode, recoveryType })),
        terminateOAGSession: logoutOAGSession => dispatch(terminateOAGSession(logoutOAGSession))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
